import { ViewData } from "./view-data";
import { DataFetchService } from "../wa-services/data-fetch-service";
import { LoggerService } from "../logger/logger-service";
import { DatabaseService } from "../wa-services/database-service";
import { FactoryService } from "../wa-services/factory-service";
import { WaHelperService } from "../wa-services/wa-helper-service";
import { LocatorInterface } from "../interfaces/locator.interface";
import { ViewDataConfigStruct } from "../interfaces/view-data.interface";
import { ResponseData } from "../fetching/wa-response/wa-api-response";
import { Observable } from "rxjs";
import { RecordHistoryItem } from "../fetching/types/record-history.item";

export class RecordHistoryListVD extends ViewData<RecordHistoryItem> {
  constructor(
    protected logger: LoggerService,
    protected fetchSrvc: DataFetchService,
    protected db: DatabaseService,
    protected factory: FactoryService,
    protected _helper: WaHelperService,
    protected _locator: LocatorInterface
  ) {
    super(logger, db, _locator);
  }

  public configureView() {
    let viewDataConf = new ViewDataConfigStruct();
    viewDataConf.maxAge = 1800;
    viewDataConf.expectedItems = "ALL";
    this.applyConfiguration(viewDataConf);
  }

  public updateData(): Observable<ResponseData> {
    return this.fetchSrvc.requestRecordHistory(this._locator, this.pageInfo());
  }

  public mapItem(rawItem: any): RecordHistoryItem {
    return new RecordHistoryItem(rawItem, this.factory);
  }
}
